import { getConfigInterceptors } from '@shared/utils'
import $axios, { RawAxiosRequestHeaders } from 'axios'

const defaultHeaders: RawAxiosRequestHeaders = {
  'Content-Type': 'application/json'
}

export const ssoAxios = $axios.create({
  baseURL: import.meta.env.VITE_APP_SSO_API,
  withCredentials: true,
  headers: defaultHeaders
})

getConfigInterceptors(ssoAxios, true, undefined, {
  ssoRefreshUrl: `${import.meta.env.VITE_APP_SSO_API}/authorization/token/refresh/`
})
